import { ApiResponse } from "../types";
import { apiClient } from "./apiClient";

export const usersApi = {
  /**
   * Link user to a company.
   * POST /api/users/:id/companies
   * Body: { companyId }
   */
  async addCompany(
    userId: number,
    companyId: number
  ): Promise<ApiResponse<unknown>> {
    try {
      await apiClient.post<unknown>(`/users/${userId}/companies`, {
        companyId,
      });
      return { success: true };
    } catch (error) {
      return {
        success: false,
        error:
          error instanceof Error ? error.message : "Unknown error occurred",
      };
    }
  },
};
